<template>
    <div class="wrap-snackbar is-flex is-justify-content-space-between is-align-items-center">
        <div class="is-flex is-justify-content-space-between is-align-items-center">
            <img :src="require('@/assets/img/folder.gif')" alt="folder-gif" class="mr-3 img-snackbar" width="40">
            <div class="mr-2">
                <p class="averta-bold label-20 label-sm-16 has-text-white">Terdapat Request Reschedule Baru</p>
                <p class="label-16 label-sm-14 has-text-white">Kamu punya {{ total }} request reschedule</p>
            </div>
        </div>
        <div>
            <button class="btn-detail label-sm-1 is-clickable averta-bold" @click="buttonCLick">Lihat Detail</button>
        </div>
    </div>
</template>

<script>

export default {
  name: 'SnackbarRescheduleSurvey',
  props: ['total'],
  methods: {
    buttonCLick () {
      this.$emit('buttonClick')
    }
  }
}
</script>

<style scoped>
.wrap-snackbar {
    background: #10BD41;
    padding: 7px 50px 11px 24px;
    position: fixed;
    width: 100%;
    z-index: 2;
}

@media only screen and (max-width: 767px) {
  .wrap-snackbar {
    top: 60px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .btn-detail {
    padding: 6px 10px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .wrap-snackbar {
    top: 66px
  }
}

@media only screen and (min-width: 1025px) {
  .wrap-snackbar {
    width: calc(100% - 70px);
  }
}

.btn-detail {
    background: none;
    border: 1px solid white;
    padding: 6px 32px;
    color: white;
}

.img-snackbar {
    border-radius: 10px;
}
</style>
